import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import NotesIcon from "@mui/icons-material/Notes";
import {
  Alert,
  Box,
  Chip,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { toJalaliFullDate } from "../../middleware/middleware";

const RequestFollowUpTimeline = ({ followUps = [] }) => {
  if (!followUps?.length) {
    return (
      <Alert severity="info" sx={{ mt: 1 }}>
        هنوز پیگیری‌ای برای این درخواست ثبت نشده است.
      </Alert>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ mt: 1 }}>
      {followUps.map((item) => (
        <Paper key={item.id} variant="outlined" sx={{ p: 1 }}>
          <Stack direction="row" flexWrap="wrap" sx={{ mb: 1, gap: 1 }}>
            <Chip size="small" label={item.followUpTypeTitle || "-"} />
            {item.callResultTitle ? (
              <Chip
                size="small"
                label={item.callResultTitle}
                color={
                  item.callResultTitle.includes("نیاز")
                    ? "warning"
                    : item.callResultTitle.includes("آماده")
                    ? "success"
                    : "default"
                }
                variant="outlined"
              />
            ) : null}
          </Stack>
          <Stack spacing={0.5}>
            <Typography variant="caption" color="text.secondary">
              <AccessTimeIcon sx={{ fontSize: 14, verticalAlign: "middle", ml: 0.5 }} />
              تاریخ ثبت: {toJalaliFullDate(item.createOn) || "-"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              <AssignmentIndIcon sx={{ fontSize: 14, verticalAlign: "middle", ml: 0.5 }} />
              ثبت کننده: {item.createdByFullName || "-"}
            </Typography>
            {item.nextFollowUpDate ? (
              <Typography variant="caption" color="warning.main">
                پیگیری بعدی: {toJalaliFullDate(item.nextFollowUpDate)}
              </Typography>
            ) : null}
            {item.note ? (
              <>
                <Divider sx={{ my: 0.5 }} />
                <Typography variant="body2" color="text.secondary">
                  <NotesIcon sx={{ fontSize: 14, verticalAlign: "middle", ml: 0.5 }} />
                  {item.note}
                </Typography>
              </>
            ) : null}
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
};

export default RequestFollowUpTimeline;
